module.exports = __webpack_public_path__ + "media/images/emblems/Roggwil-coat_of_arms-b6014301be6806a4e27949fd7749af33.svg";